export {MandatesListComponent} from "./mandates-list/mandates-list.component";
export {MandatesNavigationComponent} from "./mandates-navigation/mandates-navigation.component";
export {MandateModalComponent} from "./mandate-modal/mandate-modal.component";
export {MandateInfoComponent} from "./mandate-info/mandate-info.component";
